import React, { useState } from "react";
import { Box, Grid, Paper, Tab, Tabs, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/system";

import XRayReferral from "../xrayCollectFees/XRayReferral";
import UltrasoundReferral from "../ultrasoundCollectFees/UltrasoundReferral";
import EchoReferral from "../echoCollectFees/EchoReferral";
import LaboratoryReferral from "./LaboratoryReferral/LaboratoryReferral";
import EndoscopyReferral from "./EndoscopyReferral/EndoscopyReferral";
import CTScanReferral from "./CTScanReferral/CTScanReferral";
import MRoyReferral from "./MRoyReferral/CTScanReferral";

// Custom Styled Components
const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius,
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  backgroundColor: "#f8f9fa",
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: "capitalize",
  fontWeight: "bold",
  fontSize: "15px",
  color: "#071952",
  "&.Mui-selected": {
    color: "#071952",
    backgroundColor: "rgba(7, 25, 82, 0.1)",
    borderRadius: theme.shape.borderRadius,
  },
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  color: "#071952",
  fontWeight: "bold",
}));

// Main Patient Referral Component for Reception
const PatientReferral = () => {
  const { t } = useTranslation();

  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Grid container mt={2} mb={10}>
      <Grid item xs={12} lg={12}>
        <StyledPaper>
          {/* Patient Referral Section */}
          <StyledTypography variant="h5" gutterBottom>
            {t("reception.patientReferral") || "Patient Referral"}
          </StyledTypography>

          <StyledTypography
            variant="body2"
            color="text.secondary"
            gutterBottom
            mb={3}
          >
            {t("reception.referPatientForTests") ||
              "Refer patients for diagnostic tests and examinations"}
          </StyledTypography>

          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            centered
            variant="scrollable"
            scrollButtons="auto"
          >
            <StyledTab label={t("doctor.referXray")} />
            <StyledTab label={t("doctor.referUltrasound")} />
            <StyledTab label={t("doctor.referEcho")} />
            <StyledTab label={t("doctor.referLab")} />
            <StyledTab
              label={t("doctor.referEndoscopy", "Refer to Endoscopy")}
            />
            <StyledTab
              label={t("doctor.referCTScan", "Refer to CT Scan")}
            />
            <StyledTab label={t("doctor.referMRI", "Refer to MRI")} />
          </Tabs>

          {/* Referral Tab Content */}
          <Box mt={2}>
            {selectedTab === 0 && <XRayReferral />}
            {selectedTab === 1 && <UltrasoundReferral />}
            {selectedTab === 2 && <EchoReferral />}
            {selectedTab === 3 && <LaboratoryReferral />}
            {selectedTab === 4 && <EndoscopyReferral />}
            {selectedTab === 5 && <CTScanReferral />}
            {selectedTab === 6 && <MRoyReferral />}
          </Box>
        </StyledPaper>
      </Grid>
    </Grid>
  );
};

export default PatientReferral;
